import { updateExpirationTime } from '../../socket';
import indexedDBService from '../../utils/idb.utils';
// import safelyParseJSON from '../../utils/safelyParseJson';

export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const ADD_EVENT = 'ADD_EVENT';
export const ADD_STREAM_EVENT = 'ADD_STREAM_EVENT';
export const LOAD_EVENT = 'LOAD_EVENT';
export const LOAD_EVENTS = 'LOAD_EVENTS';
export const UPDATE_EVENT_BY_DIV_ID = 'UPDATE_EVENT_BY_DIV_ID';
export const DELETE_LAST_EVENT = 'DELETE_LAST_EVENT';
export const FILE_UPLOADED_EVENT = 'FILE_UPLOADED_EVENT';
export const ADD_LOADER_EVENT = 'ADD_LOADER_EVENT';
export const REMOVE_LOADER_EVENT = 'REMOVE_LOADER_EVENT';

type EventType =
  | typeof CLEAR_EVENTS
  | typeof ADD_EVENT
  | typeof ADD_STREAM_EVENT
  | typeof LOAD_EVENT
  | typeof LOAD_EVENTS
  | typeof UPDATE_EVENT_BY_DIV_ID
  | typeof DELETE_LAST_EVENT
  | typeof FILE_UPLOADED_EVENT
  | typeof ADD_LOADER_EVENT
  | typeof REMOVE_LOADER_EVENT;

async function saveToIndexedDB(event: any) {
  const userNumber = localStorage.getItem('userNumber') as string;
  const timestamp = event.timestamp
    ? new Date(event.timestamp).getTime()
    : new Date().getTime();
  try {
    await indexedDBService.addEvent(event, userNumber, timestamp);
  } catch (error) {
    console.error('Error adding data to IndexedDB:', error);
  }
}

async function updateToIndexedDB(id: string, event: any) {
  try {
    await indexedDBService.updateEvent(id, event);
  } catch (error) {
    console.error('Error updating data to IndexedDB:', error);
  }
}

async function removeFromIndexedDB(key: number) {
  try {
    await indexedDBService.deleteEvent(key);
  } catch (error) {
    console.error('Error removing from IndexedDB:', error);
  }
}

const initialState: any[] = []; // loadFromLocalStorage();

const eventReducer = (
  state = initialState,
  action: { type: EventType; payload: any; streamEvent: boolean },
): any[] => {
  switch (action.type) {
    case CLEAR_EVENTS: {
      const userNumber = localStorage.getItem('userNumber') as string;
      indexedDBService.purgeEventsExceptForUser(userNumber);
      return [];
    }
    case LOAD_EVENT: {
      return [...state, { ...action.payload.event }];
    }
    case LOAD_EVENTS: {
      return [...state, ...action.payload];
    }
    case ADD_STREAM_EVENT: {
      saveToIndexedDB(action.payload);
      return state;
    }
    case ADD_EVENT: {
      // return [...state, { ...action.payload }];

      if (action.payload.actionType === 'menuCard') {
        return state;
      }
      const newEvents = [...state, { ...action.payload }];
      // const lastEvents = newEvents.slice(-10);
      // const updatedState = { ...state, events: lastEvents }; // Keep only the recent 10 events

      // Save to IndexedDB (including auth cards for persistence)
      if (!action.streamEvent) {
        saveToIndexedDB(
          action.payload.type === 'file'
            ? { ...action.payload, loading: false, uploaded: true }
            : action.payload,
        );
      }
      if (
        action.payload.actionType !== 'feedback_card' &&
        !(
          typeof action?.payload?.msg === 'string' &&
          action?.payload?.msg?.startsWith("We haven't received any")
        )
      ) {
        updateExpirationTime();
      } else {
        localStorage.setItem('disconnecting', 'true');
      }
      return newEvents;
    }
    case UPDATE_EVENT_BY_DIV_ID: {
      const { divId, msg } = action.payload;
      const newEvents = state.map((event) =>
        event.divId === divId ? { ...event, msg } : event,
      );

      // const lastEvents = newEvents.slice(-10);
      // saveToLocalStorage(lastEvents);
      return newEvents;
    }
    case DELETE_LAST_EVENT: {
      // return [...state, { ...action.payload }];
      const lastCard = state.slice(-1)[0];
      const removeLastCard = state.slice(0, -1);

      // const lastEvents = removeLastCard.slice(-10);

      // const updatedState = { ...state, events: lastEvents }; // Keep only the recent 10 events
      // saveToLocalStorage(updatedState.events);
      removeFromIndexedDB(lastCard.id);

      return removeLastCard;
    }
    case FILE_UPLOADED_EVENT: {
      const { divId } = action.payload;
      const newEvents = state.map((event) =>
        event.divId === divId
          ? { ...event, loading: false, uploaded: true }
          : event,
      );

      // const lastEvents = newEvents.slice(-10);
      // saveToLocalStorage(lastEvents);
      // saveToIndexedDB({ ...action.payload, loading: false });
      updateToIndexedDB(action.payload.divId, {
        ...action.payload,
        loading: false,
        uploaded: true,
      });
      return newEvents;
    }
    case ADD_LOADER_EVENT: {
      return [...state, { ...action.payload }];
    }

    case REMOVE_LOADER_EVENT: {
      return state.filter((event) => event.type !== 'loader');
    }
    default:
      return state;
  }
};

export default eventReducer;
